import * as moment from 'moment/moment';
import { PaymentMethodEnum } from '../../../../interfaces/idefend/payment-method.enum';
import { CalculateOfferPayload } from '../../shared/interfaces/calculate-offer-payload.interface';
import { CreationLockPayload } from '../../shared/interfaces/creation-lock-payload.interface';
import { FirstStepPayload } from '../../shared/interfaces/first-step-payload.interface';
import { SecondStepPayload } from '../../shared/interfaces/second-step-payload.interface';

export function newIdefendConditionsMapper(
  firstStepPayload: FirstStepPayload,
  secondStepPayload: SecondStepPayload,
  response: CalculateOfferPayload | CreationLockPayload,
): void {
  // NEW iDEFEND CONDITIONS
  if (!response.vehicleSnapshot.purchasedOn) {
    // purchasedOn FLEX
    if (firstStepPayload.selectedInsuranceVariant === 'FLEX') {
      response.vehicleSnapshot.purchasedOn = moment().format('YYYY-MM-DD');
    }

    // purchasedOn MAX
    if (
      firstStepPayload.selectedInsuranceVariant === 'MAX' ||
      firstStepPayload.selectedInsuranceVariant === 'T-MAX'
    ) {
      const vehicleBuyDate = firstStepPayload.vehicleBuyDate;
      response.vehicleSnapshot.purchasedOn =
        moment(vehicleBuyDate).format('YYYY-MM-DD');
    }

    // purchasedOn MAX AC
    if (
      firstStepPayload.selectedInsuranceVariant === 'MAX AC' ||
      firstStepPayload.selectedInsuranceVariant === 'T-MAX AC'
    ) {
      response.vehicleSnapshot.purchasedOn = moment(
        firstStepPayload.vehicleBuyDate,
      ).format('YYYY-MM-DD');
    }
  }

  // evaluationDate MAX
  if (
    firstStepPayload.selectedInsuranceVariant === 'MAX' ||
    firstStepPayload.selectedInsuranceVariant === 'T-MAX'
  ) {
    response.vehicleSnapshot.evaluationDate = null;
  }

  // evaluationDate MAX AC
  if (
    firstStepPayload.selectedInsuranceVariant === 'MAX AC' ||
    firstStepPayload.selectedInsuranceVariant === 'T-MAX AC'
  ) {
    response.vehicleSnapshot.evaluationDate = moment(
      firstStepPayload.acPolicyRenewalDate,
    ).format('YYYY-MM-DD');
  }

  // SECOND STEP INSTALMENT PAYMENT WORKAROUND
  if (secondStepPayload?.paymentType === 'PT_LS_AIS') {
    response.options.PAYMENT_METHOD = PaymentMethodEnum.PAYU_INSTALLMENTS;
  }
}
